/*--------------------------------------------------------------
# Custom JS
--------------------------------------------------------------*/

// Importation Vue
import {createApp} from 'vue/dist/vue.esm-bundler'
import {createPinia} from 'pinia'
import {i18nVue} from 'laravel-vue-i18n'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

// Creation et montage composants/directives Vue
import SearchReserv from "./components/SearchReserv.vue";
import ModalConfigReserv from "./components/configurator/ModalConfigReserv.vue";
import ConfirmModal from "./components/common/ConfirmModal.vue";
import PlanningFront from './components/PlanningFront.vue';
import PrestationOrder from './components/customer/PrestationOrder.vue'
import CustomerPrestations from './components/customer/CustomerPrestations.vue'
import bootstrapDropdownDirective from './directives/bootstrapDropdownDirective.js';
import openConfigurateur from './directives/openConfigurateurDirective.js';
import SafeHtml from '../../../../packages/Divioseo/GTDrive/src/Resources/assets/js/directives/vSafeHtml.js';
import CircuitDatepicker from './components/CircuitDatepicker.vue'
import GlobalLoader from './components/GlobalLoader.vue'
import CartIndex from "./components/Checkout/Cart/CartIndex.vue";
import BtnAddToCart from './components/Checkout/BtnAddToCart.vue'
import GiftCardActivate from './components/gift-card/GiftCardActivate.vue'
import GiftCardSelector from './components/gift-card/GiftCardSelector.vue'
import CookieConsent from './components/CookieConsent.vue'
import axios from 'axios';
import tracking from './modules/tracking.js';


// Importation de simple-parallax-js
import simpleParallax from 'simple-parallax-js/vanilla';

// Importation AOS (Animate On Scroll)
import AOS from 'aos';
import 'aos/dist/aos.css'; // Importation des styles CSS d'AOS

// Importation des modules
import "./modules/bootstrap-init.js";
import "./modules/bootstrap-dropdown-init.js";
import "./modules/swiper-init.js";
import "./modules/easepick-init.js";
import "./modules/href.js";
import "./modules/choices-init.js"; // Removed in favor of bootstrap-dropdown-init.js
import "./modules/viewportHeight.js";

import {preventDefaultLinks} from "./modules/dom-utils.js";

// Configuration axios partagée (CSRF via meta tag, le cookie XSRF-TOKEN est
// désormais HttpOnly). Shannon 2026-04-22 ticket #127 finding P1 #8.
// Les defaults ci-dessous affectent toutes les importations `import axios from 'axios'`
// dans les composants/stores (axios est un singleton).
import "./modules/axios-csrf.js";
import {initRegistrationForm} from "./modules/registration-form.js";

tracking.installCartTracking(axios);
tracking.init();
window.gtdriveTracking = tracking;

import * as bootstrap from 'bootstrap';

window.bootstrap = bootstrap;

// Importation d'images
import.meta.glob(["../img/**"]);

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

let app = createApp({})
    .directive('choices', bootstrapDropdownDirective)
    .directive('open-configurateur', openConfigurateur)
    .directive('safe-html', SafeHtml)
    .component('SearchReserv', SearchReserv)
    .component('ModalConfigReserv', ModalConfigReserv)
    .component('ConfirmModal', ConfirmModal)
    .component('BtnAddToCart', BtnAddToCart)
    .component('CheckoutCartIndex', CartIndex)
    .component('PlanningFront', PlanningFront)
    .component('circuit-datepicker', CircuitDatepicker)
    .component('PrestationOrder', PrestationOrder)
    .component('CustomerPrestations', CustomerPrestations)
    .component('GlobalLoader', GlobalLoader)
    .component('GiftCardActivate', GiftCardActivate)
    .component('GiftCardSelector', GiftCardSelector)
    .component('CookieConsent', CookieConsent)
    .use(pinia)
    .use(i18nVue, {
        resolve: async lang => {
            const langs = import.meta.glob('../../../../lang/*/configurator.json');
            return await langs[`../../../../lang/${lang}/configurator.json`]();
        }
    })
    .mount('#app');


// Initialisation JS après le chargement du DOM
document.addEventListener("DOMContentLoaded", function () {
    preventDefaultLinks();
    initRegistrationForm();
    const cookieConsentOpen = document.querySelector('[data-cookie-consent-open]');
    cookieConsentOpen?.addEventListener('click', () => tracking.openConsent());

    // Déconnexion : purger la configuration du configurateur persistée en
    // localStorage pour éviter que la popup de reprise apparaisse avec les
    // choix de la session précédente.
    document.querySelectorAll('a[href*="customer/logout"]').forEach(link => {
        link.addEventListener('click', () => {
            try {
                ['stage_id', 'voiture_id', 'circuit_id', 'nb_tours'].forEach(key => {
                    localStorage.removeItem(`configurateur.${key}`);
                });
                localStorage.removeItem('configurateur');
            } catch (e) {
                // localStorage indisponible : on ignore, la déconnexion continue
            }
        });
    });

    const getAOSOffset = () => {
        return window.innerWidth < 768 ? 40 : 100; // 80px pour mobile, 200px pour desktop
    };

    // Initialisation d'AOS avec des options personnalisées
    AOS.init({
        duration: 800,           // durée des animations en ms
        easing: 'ease-in-out',   // fonction d'accélération 
        once: true,             // animation une seule fois ou à chaque défilement
        mirror: false,           // les éléments doivent s'animer à la sortie?
        offset: getAOSOffset(),             // offset (en px) à partir du déclenchement des animations
        delay: 0,                // valeurs en ms
        //anchorPlacement: 'top-bottom'
    });


    // Initialisation de simpleParallax sur les images souhaitées
    //var cardfocus = document.querySelectorAll('.card-focus .card-img');
    var griditems = document.querySelectorAll('.grid-item .figure-img');
    new simpleParallax(griditems, {
        delay: 1,
        orientation: 'left',
        transition: 'cubic-bezier(0,0,0,1)'
    });


    /* gestion scroll pour le header et la recherche */

    const searchContainer = document.getElementById('search-container');
    const searchToggler = document.getElementById('search-toggler');

    // Vérification de l'existence des éléments avant d'ajouter les écouteurs d'événements
    if (searchContainer && searchToggler) {

        // État initial : searchContainer visible, toggler caché
        //searchContainer.style.display = 'block';
        //searchToggler.style.display = 'none';

        // Vrai si une liste déroulante (voitures ou circuits) du SearchReserv
        // est actuellement ouverte : dans ce cas on n'escamote pas la zone,
        // sinon la liste ouverte (positionnée en absolute sous le select)
        // disparaît au moindre scroll pour consulter toutes les voitures.
        const isSearchListOpen = () =>
            !!searchContainer.querySelector('.cars-selection, .circuits-selection');

        let lastScrollTop = 0;
        window.addEventListener('scroll', function () {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > 120 && !isSearchListOpen()) {
                // Scroll vers le bas OU vers le haut, mais pas proche du haut de page
                searchContainer.classList.add('hide');
                setTimeout(() => {
                    searchToggler.classList.add('visible');
                }, 70);
            } else {
                // Si on est proche du haut de la page ou qu'une liste est
                // ouverte, on affiche la recherche
                searchContainer.classList.remove('hide');
                searchToggler.classList.remove('visible');
            }

            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        });


        searchToggler.addEventListener('click', function () {
            // Afficher search, cacher toggler
            searchContainer.classList.remove('hide');
            searchToggler.classList.remove('visible');
        });
    }

    /* gestion scroll pour le header mobile */
    const header = document.getElementById('header');
    const promoBanner = document.getElementById('promo-banner');
    const logoNavigation = document.getElementById('logo-navigation');
    const mainLogo = document.getElementById('main-logo');
    const menuButton = document.querySelector('.btn.btn-light.fw-normal[data-bs-toggle="offcanvas"]');
    const phoneLi = document.querySelector('#main-menu ul li.d-flex.flex-column.align-items-start.lh-sm');
    const giftCardButton = document.querySelector('a.d-flex.d-lg-none.btn.btn-primary.text-white.fw-bold');
    const mainMenu = document.getElementById('main-menu');

    // Vérifier les éléments essentiels pour le scroll header (pas tous obligatoires)
    if (logoNavigation && mainLogo && menuButton) {
        let lastScrollY = 0;
        let isScrolled = false;

        // Sauvegarder les positions originales
        const originalMenuParent = menuButton.parentElement;
        const originalMenuNextSibling = menuButton.nextElementSibling;
        const originalPhoneParent = phoneLi ? phoneLi.parentElement : null;
        const originalPhoneNextSibling = phoneLi ? phoneLi.nextElementSibling : null;
        const logosContainer = document.getElementById('logos');
        const logosUl = logosContainer ? logosContainer.querySelector('ul') : null;

        window.addEventListener('scroll', function () {
            const scrollY = window.pageYOffset || document.documentElement.scrollTop;

            // Détection mobile (largeur < 992px pour Bootstrap lg breakpoint)
            if (window.innerWidth < 992) {
                if (scrollY > 50 && !isScrolled) {
                    // Scroll vers le bas : actions DOM
                    if (promoBanner) {
                        promoBanner.classList.add('header-hidden');
                    }
                    logoNavigation.classList.add('header-sticky');

                    // Masquer le logo principal
                    mainLogo.style.display = 'none';

                    // Masquer le bouton "J'ai un bon cadeau"
                    if (mainMenu) {
                        mainMenu.style.display = 'none';
                    }

                    // Déplacer le bouton menu à la place du logo
                    if (logosContainer) {
                        logosContainer.insertBefore(menuButton, mainLogo);
                    }
                    menuButton.classList.add('header-menu-visible');

                    // Déplacer le téléphone au début de l'ul dans #logos
                    if (phoneLi && originalPhoneParent && logosUl) {
                        logosUl.insertBefore(phoneLi, logosUl.firstChild);
                        phoneLi.classList.add('header-phone-visible');
                    }

                    isScrolled = true;
                } else if (scrollY <= 50 && isScrolled) {
                    // Retour vers le haut : restaurer l'état initial
                    if (promoBanner) {
                        promoBanner.classList.remove('header-hidden');
                    }
                    logoNavigation.classList.remove('header-sticky');

                    // Restaurer le logo principal
                    mainLogo.style.display = '';

                    // Restaurer le bouton "J'ai un bon cadeau"
                    if (mainMenu) {
                        mainMenu.style.display = '';
                    }

                    // Remettre le bouton menu à sa place originale
                    if (originalMenuNextSibling) {
                        originalMenuParent.insertBefore(menuButton, originalMenuNextSibling);
                    } else {
                        originalMenuParent.appendChild(menuButton);
                    }
                    menuButton.classList.remove('header-menu-visible');

                    // Remettre le téléphone à sa place originale
                    if (phoneLi && originalPhoneParent) {
                        if (originalPhoneNextSibling) {
                            originalPhoneParent.insertBefore(phoneLi, originalPhoneNextSibling);
                        } else {
                            originalPhoneParent.appendChild(phoneLi);
                        }
                        phoneLi.classList.remove('header-phone-visible');
                    }

                    isScrolled = false;
                }
            }

            lastScrollY = scrollY;
        });

        // Gérer le redimensionnement de la fenêtre
        window.addEventListener('resize', function () {
            if (window.innerWidth >= 992 && isScrolled) {
                // Réinitialiser sur desktop
                if (promoBanner) {
                    promoBanner.classList.remove('header-hidden');
                }
                logoNavigation.classList.remove('header-sticky');
                mainLogo.style.display = '';

                if (mainMenu) {
                    mainMenu.style.display = '';
                }

                if (giftCardButton) {
                    giftCardButton.style.display = '';
                }

                // Remettre le bouton menu à sa place originale
                if (originalMenuNextSibling) {
                    originalMenuParent.insertBefore(menuButton, originalMenuNextSibling);
                } else {
                    originalMenuParent.appendChild(menuButton);
                }
                menuButton.classList.remove('header-menu-visible');

                // Remettre le téléphone à sa place originale
                if (phoneLi && originalPhoneParent) {
                    if (originalPhoneNextSibling) {
                        originalPhoneParent.insertBefore(phoneLi, originalPhoneNextSibling);
                    } else {
                        originalPhoneParent.appendChild(phoneLi);
                    }
                    phoneLi.classList.remove('header-phone-visible');
                }

                isScrolled = false;
            }
        });
    }

    // The mobile navigation changes height when it becomes sticky.
    // Measure its actual lower edge instead of keeping the desktop offset.
    if (header && logoNavigation && document.getElementById('search-zone')) {
        const updateSearchOffset = () => {
            const bottom = Math.max(0, header.getBoundingClientRect().bottom,
                logoNavigation.getBoundingClientRect().bottom);
            document.documentElement.style.setProperty('--header-bottom', `${bottom}px`);
        };
        new ResizeObserver(updateSearchOffset).observe(logoNavigation);
        window.addEventListener('scroll', updateSearchOffset, {passive: true});
        window.addEventListener('resize', updateSearchOffset);
        updateSearchOffset();
    }

    /* menu mobile - circuits dropdown (page home uniquement) */
    const circuitsDropdown = document.getElementById('circuitsDropdown');
    if (circuitsDropdown) {
        document.querySelectorAll('.dropdown-menu [data-bs-toggle="pill"]').forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();
                // Ferme le dropdown
                var dropdown = bootstrap.Dropdown.getOrCreateInstance(circuitsDropdown);
                dropdown.hide();

                var targetSelector = this.getAttribute('data-bs-target');
                var target = document.querySelector(targetSelector);

                // Si c'est un sous-circuit CPR, il faut aussi activer le tab principal CPR
                if (target && targetSelector.startsWith('#home-cpr-sub-circuit-content-')) {
                    // Active le tab principal CPR
                    document.querySelectorAll('.tab-pane').forEach(function (pane) {
                        pane.classList.remove('show', 'active');
                    });
                    var mainCPR = document.getElementById('home-main-circuit-cpr-content');
                    if (mainCPR) mainCPR.classList.add('show', 'active');

                    // Active le sous-circuit CPR
                    document.querySelectorAll('#home-cpr-sub-circuit-tab-content .tab-pane').forEach(function (pane) {
                        pane.classList.remove('show', 'active');
                    });
                    target.classList.add('show', 'active');
                } else if (target) {
                    // Désactive toutes les tabs
                    document.querySelectorAll('.tab-pane').forEach(function (pane) {
                        pane.classList.remove('show', 'active');
                    });
                    // Active la cible
                    target.classList.add('show', 'active');
                }
            });
        });
    }
});
